export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 85,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.order_package_materialNo') || '包装编号',
    field: 'materialNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.order_package_materialName') || '包装名称',
    field: 'materialDisplayName',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.order_tab_group_order_package_size') || '包装尺寸',
    field: 'materialSpec',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_package_boxVolume') || '包装体积(立方cm)',
    field: 'boxVolume',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_package_boxWeight') || '包装箱重量(g)',
    field: 'boxWeight',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_is_specify') || '指定供应商',
    field: 'isSpecify',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'isSpecify' },
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_scm_name') || '供应商名称',
    field: 'scmName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_form_label_isCustomerProvide') || '是否客供',
    field: 'isCustomerProvide',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'isCustomerProvide' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_time') || '修改时间',
    field: 'modifyTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
